export const getSecureCookieName = (name: string) => {
  return `${process.env.NODE_ENV === 'production' ? '__Host-' : ''}${name}`
}


export const getRootDomain = (host: string) => {
  if (host === 'localhost') {
    return 'localhost'
  }
  const domainExpression = /^(?:.*?\.)?([a-zA-Z0-9\-_]{3,}\.(?:\w{2,8}|\w{2,4}\.\w{2,4}))$/
  const rootDomain = host.match(domainExpression)

  if (rootDomain) {
    return rootDomain[1]
  }
}